/**
 * Remove itens com show: false e ramos vazios após filtrar filhos.
 */
export const filterNavItems = (items) => {
  if (!items || !items.length) return [];

  return items
    .filter((item) => item.show !== false)
    .map((item) => {
      if (item.items) {
        const children = filterNavItems(item.items);
        if (children.length === 0) return null;
        return { ...item, items: children };
      }
      return item;
    })
    .filter(Boolean);
};
